<template>
    <div :key="companyId" class="page-content compania-mea-wrapper">
        <SketchBreadcrumb pageName="Compania mea"></SketchBreadcrumb>
        <div v-if="!loading" class="padding-box">
            <div class="white-box flex space-between align-center">
                <div ref="scrollTo">
                    <h3 class="module-title">Instrument de completare detalii despre compania ta</h3>
                    <p>Această sectíune cuprinde informațiile despre compania ta. Toate informațiile sunt necesare în generarea documentelor / anexelor ce însoțesc cererea de finanțare.
                        Ne dorim ca acest proces să fie unul simplu, astfel am precompletat pentru tine, mai multe secțiuni. Poți edita aceste secțiuni, acolo unde este cazul.</p>
                </div>
                <img src="@/assets/images/M3/M3Sketch/warning-sign.png" class="warning-sign">
            </div>
            <InformatiiGenerale v-if="informatiiGenerale" :spendings="allData && allData.m3_project ? allData.m3_project.spendings : []" :data="informatiiGenerale" :typeChanged="typeChanged" :activeCompany="activeCompany" @immUpChanged="immUp = $event" @unsavedChanges="handleUnsavedChangesEmit()" @formComplete="completePage('informatiiGenerale', true)" @formIncomplete="completePage('informatiiGenerale', false)"></InformatiiGenerale>
            <SediuSocial v-if="sediuSocial" :data="sediuSocial" :activeCompany="activeCompany" @unsavedChanges="handleUnsavedChangesEmit()" @formComplete="completePage('sediuSocial', true)" @formIncomplete="completePage('sediuSocial', false)"></SediuSocial>
            <Asociati :associates="associates" :associatesCompleted="associatesCompleted" :activeCompany="activeCompany" @asociatesComplete="associates = $event" @formComplete="completePage('asociati', true)" @formIncomplete="completePage('asociati', false)" @associateAdded="associates = $event"></Asociati>
            <ReprezentantLegal :associates="associates" :delegate="delegate" :activeCompany="activeCompany" :legaturi="legaturi" @associateCompanies="companies = $event" @unsavedChanges="handleUnsavedChangesEmit()" @formComplete="completePage('reprezentantLegal', true)" @formIncomplete="completePage('reprezentantLegal', false)"></ReprezentantLegal>
            <TipCompanie :enterprise="enterprise" :immType="immType" :activeCompany="activeCompany" :asociatiFirma="asociatiFirma" :companies="companies" :immUp="immUp" @companyTypeChanged="companyTypeChanged($event)" @formComplete="completePage('tipCompanie', true)" @formIncomplete="completePage('tipCompanie', false)"></TipCompanie>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>
        <LoadingSpinner v-else></LoadingSpinner>
        <ChangeRoutePopup :schimbaModal="showModal"
                          @hideTempModal="showModal = false"
                          @changeRoute="leavePage($event)"
                          @achizitiiChanged="$emit('achizitiiChanged')"
        ></ChangeRoutePopup>
    </div>

</template>

<script>
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import InformatiiGenerale from '../components/companie-forms/InformatiiGenerale'
    import SediuSocial from '../components/companie-forms/SediuSocial'
    import Asociati from '../components/companie-forms/Asociati'
    import ReprezentantLegal from '../components/companie-forms/ReprezentantLegal'
    import TipCompanie from '../components/companie-forms/TipCompanie'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import ChangeRoutePopup from "../components/ChangeRoutePopup";
    import {changeRoute, checkFormForInputs} from "../../../../../helpers/helpers";
    import {formatUtcDate} from '@/helpers/helpers'
    import {BIconChevronUp} from 'bootstrap-vue'

    export default {
        name: 'CompaniaMea',
        components: {
            SketchBreadcrumb,
            InformatiiGenerale,
            SediuSocial,
            Asociati,
            ReprezentantLegal,
            TipCompanie,
            LoadingSpinner,
            ChangeRoutePopup,
            BIconChevronUp
        },

        data() {
            return {
                loading: true,
                associatesCompleted: false,
                associates: [],
                legaturi: [],
                asociatiFirma: [],
                delegate: {},
                enterprise: 0,
                activeCompany: null,
                data: null,
                immType: null,
                informatiiGenerale: null,
                sediuSocial: null,
                completed: false,
                showModal: false,
                next: null,
                initialInputs: null,
                completedPage: {
                    informatiiGenerale: false,
                    sediuSocial: false,
                    asociati: false,
                    reprezentantLegal: false,
                    tipCompanie: false,
                },
                companies: null,
                typeChanged: null,
                immUp: null
            }
        },
        computed: {
            companyId() {
                return this.$store.getters['m3Sketch/m3Company'] ? this.$store.getters['m3Sketch/m3Company'].id : 0
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch:{
            changeCId: {
                handler: function() {
                    this.changeCompany()
                },
                deep: false
            },
            allData: {
                handler () {
                    this.changeCompany();
                    this.immType = this.allData ? this.allData.imm_type : null
                },
                deep: true,
                immediate: true
            }
        },

        beforeRouteLeave (to, from, next) {

            this.next = next;
            if(to.path === '/login' || to.path === '/logout')
                this.next();

            if(this.completed) {
                this.$emit('achizitiiChanged')
                this.next();
            }
            else {
                if(checkFormForInputs(this.initialInputs))
                    this.showModal = true;
                else {
                    this.$emit('achizitiiChanged')
                    this.next();
                }
            }
        },
        mounted() {
            /*this.getTermeneLegaturi()*/
            // this.changeCompany()
            this.activeCompany = this.companyId
            this.initialInputs = document.getElementsByTagName('input');
            this.immType = this.allData ? this.allData.imm_type : null
        },
        methods: {
            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
            companyTypeChanged(tip) {
                this.typeChanged = tip
                this.$emit('companyTypeChanged', tip)
            },
            formatUtcDate,
            changeCompany() {
                if(this.allData){
                    this.data = this.allData;
                    this.informatiiGenerale = {
                        name: this.data.name,
                        business_type: this.data.business_type,
                        vat_status: this.data.vat_status,
                        imm_type: this.data.imm_type,
                        business_id: this.data.business_id,
                        reg_no: this.data.reg_no,
                        main_caen: this.data.main_caen,
                        general_information_saved: this.data.general_information_saved,
                        register_date: this.data.register_date,
                    }
                    this.sediuSocial = {
                        address: this.data.address,
                        state: this.data.state,
                        city: this.data.city,
                        district: this.data.district,
                        street: this.data.street,
                        street_no: this.data.street_no,
                        bl: this.data.bl,
                        bl_no: this.data.bl_no,
                        floor: this.data.floor,
                        apt: this.data.apt,
                        postal_code: this.data.postal_code,
                        phone: this.data.phone,
                        email: this.data.email,
                    }
                    if(this.data.associates && this.data.associates.length === 0) {
                        this.getTermene()
                    } else {
                        this.associates = this.data.associates
                        this.getTermeneLegaturi()
                        this.associatesCompleted = true
                    }
                    this.delegate = this.data.delegate
                    this.enterprise = this.data.enterprise_type
                }
                this.loading = false;
                this.$store.dispatch('pageLoading/setLoading', false)
            },
            completePage(event, status) {

                switch (event){

                case 'informatiiGenerale':
                    this.completedPage.informatiiGenerale = status;
                    break;

                case 'sediuSocial':
                    this.completedPage.sediuSocial = status;
                    break;

                case 'asociati':
                    this.completedPage.asociati = status;
                    break;

                case 'reprezentantLegal':
                    this.completedPage.reprezentantLegal = status;
                    break;

                case 'tipCompanie':
                    this.completedPage.tipCompanie = status;
                    break;

                }
                this.checkCompleted();
            },

            checkCompleted(){

                this.completed = this.completedPage.sediuSocial && this.completedPage.informatiiGenerale && this.completedPage.asociati && this.completedPage.reprezentantLegal && this.completedPage.tipCompanie;

                this.section = {
                    section: 'compania-mea'
                }

                if(this.completed){
                    this.$store.dispatch('pages/addPage', this.section);
                    this.$emit('unsavedChanges', false)
                }
                else{
                    this.$store.dispatch('pages/removePage', this.section);
                }
            },

            leavePage(event){
                changeRoute(event, this.next);

                if(!event)
                    this.showModal = false;
            },

            handleUnsavedChangesEmit(){
                this.$emit('unsavedChanges', checkFormForInputs(this.initialInputs))
            },

            getTermene() {
                axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v4')
                    .then(response => {
                        if(response && response.data && response.data.aa && response.data.aa.asociati){
                            this.asociatiFirma = response.data.aa.asociati
                            this.associates = response.data.aa.asociati.map((asociat) => {
                                return {
                                    birthdate_place: asociat.cui || asociat.tip_lista ? '' : formatUtcDate(asociat.dataNastere, 'DD.MM.YYYY') + ', ' +  asociat.loc_n,
                                    capital_contribution: asociat.aport,
                                    citizenship: asociat.cetatenie,
                                    function: asociat.functie,
                                    cnp: '',
                                    companie: asociat.cui ? asociat.nume : '',
                                    cui: asociat.cui,
                                    gender: '',
                                    id_no: '',
                                    id_released_at: '',
                                    id_released_by: '',
                                    id_series: '',
                                    id_type: '',
                                    name: asociat.cui ? '' : asociat.nume,
                                    social_capital: asociat.procentaj ? asociat.procentaj.toString() + '%' : '0%',
                                    tip: asociat.cui ? 1 : 0
                                }
                            })
                            this.legaturi = response.data.aa.lvl2
                        }
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
            },
            getTermeneLegaturi() {
                axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v4')
                    .then(response => {
                        if(response && response.data && response.data.aa && response.data.aa.lvl2){
                            this.legaturi = response.data.aa.lvl2
                        }
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
            }
        }
    }
</script>
<style>
@media screen and (max-width: 1441px) {
  .compania-mea-wrapper .form-group .form-row,
  .compania-mea-wrapper .select-person .alege-asociat{
    flex-direction: column;
    align-items: flex-start;
  }
  .compania-mea-wrapper .select-person .alege-asociat p {
    text-align: left;
    width: 100%;
    margin-bottom: 5px;
  }
  .compania-mea-wrapper .select-person {
    align-items: flex-end;
  }
  .compania-mea-wrapper .select-person .yellow-button {
    height: 33px;
  }
  .compania-mea-wrapper .form-group .form-row legend {
    text-align: left;
    max-width: 100%;
  }
  .compania-mea-wrapper .custom-responsive {
    margin-left: 0px!important;
  }
  .compania-mea-wrapper .custom-responsive .col-lg-10,
  .compania-mea-wrapper .custom-responsive .col-lg-9,
  .compania-mea-wrapper .custom-responsive .col-lg-8{
    max-width: 100%;
  }
  .compania-mea-wrapper .responsive-redefine{
    justify-content: space-between;
  }
  .compania-mea-wrapper .wider-input legend {
    margin-left: 0;
  }
  .compania-mea-wrapper .wider-input input {
    width: 100%;
  }
  .compania-mea-wrapper .wider-input img {
    right: 15px;
  }
  .compania-mea-wrapper .asociati-first-input {
    width: 58%;
  }
  .cnp-responsive,
   .compania-mea-wrapper .w-68{
    width: 68% !important;
  }
   .compania-mea-wrapper .w-58 {
    width: 58% !important;
  }
   .compania-mea-wrapper .w-40 {
    width: 40% !important;
  }
   .compania-mea-wrapper .w-48 {
    width: 48% !important;
  }
   .compania-mea-wrapper .w-100 {
    width: 100% !important;
  }
  .nodiv div {
    width: 100%!important;
  }
  .nodiv img {
    top: 40px;
    right: 15px;
  }
  .w-96 {
    width: 96.5% !important;
  }
  .smallerLabel.custom-responsive {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }
  .smallerLabel.custom-responsive legend {
    text-align: left;
  }
  .mobile-mb {
    margin-bottom: 1.5rem!important;
  }
  .no-mt legend {
    margin-top: 0!important;
  }

}
@media screen and (max-width: 1367px) {
 .compania-mea-wrapper hr.mt-5 {
    margin-top: 1rem!important;
  }

}
</style>
<style scoped>
.padding-box{
    padding: 20px;
    padding-bottom: 40px !important;
    position: relative;
}
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -25px;
    left: 100%;
    color: #fff;
    z-index: 9;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}

</style>
